import { ResetPageReason } from './payer-onboarding-generated';
import { ModalType } from './modals/modal-type';

export namespace PayerOnboardingUserAction {
	export class SubmitCurrentPage {
	}
	export class ChangeMobileNumber {
	}
	export class PreviousPage {
	}

	export class OpenModalDialog {
		constructor(public modalType: ModalType) { }
	}

	export class RequestConfirmationCode {
		constructor(public useVoiceCall?: boolean) { }
	}

	export class RequestResendOfConfirmationCode {
		constructor(public useVoiceCall?: boolean) { }
	}

	export class ResetPageBecauseOfError {
		constructor(public reason?: ResetPageReason) { }
	}

	export class Login {
	}

	export class GiveNow {
	}

	export class SkipPaymentMethod {
	}

	export class ChangeBankDetails {
	}

	export class FetchAppContentCard {
	}
}

export type PayerOnboardingUserAction = typeof PayerOnboardingUserAction[keyof typeof PayerOnboardingUserAction]['prototype'];
